<div class="body-container mx-auto pt-4 pt-sm-5">
  <header>
    <h1 class="page-title text-center">
      Registration
    </h1>
  </header>
  <p class="page-subtitle text-center mt-4">
    We sent a verification code to <span style="color: #CD0000">{{ emailAddress }}</span>. It can take up to
    10 minutes to receive. Please also check your spam folder.
  </p>
  <p
    class="page-subtitle text-center my-4"
    style="margin-bottom: 2.5rem;"
  >
    Please enter the verification code here:
  </p>

  <div class="text-center">
    <app-verification-code-input
      [formControl]="codeCtrl"
      [codeLength]="codeLength"
    ></app-verification-code-input>
  </div>
  <div class="action-container">
    <button
      class="btn btn-danger btn-block"
      [attr.disabled]="!continueBtnEnabled ? '' : null"
      (click)="onContinue()"
    >Continue</button>
    <button
      *ngIf="!continueBtnEnabled"
      class="btn btn-danger btn-block"
      [attr.disabled]="!resendCodeBtnEnabled ? '' : null"
      (click)="toggleCodeSent()"
    >Resend Code</button>
  </div>
  <p
    *ngIf="count && !continueBtnEnabled"
    class="lato italic text-center mt-2 timer-hint"
  >
    Able to resend code in {{ count }}s
  </p>
</div>
